// extracted by mini-css-extract-plugin
export default {"container":"Block_container__MYI5Q","Main":"Block_Main__HognX","Background":"Block_Background__KoI14","TitleWrapper":"Block_TitleWrapper__4VjM-"};